<template>
  <div class="bg-gray-200 min-h-screen">
    <div class="max-w-6xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
      <h1 class="text-3xl font-bold text-gray-800 mb-4">How may I help ?</h1>
      <p class="text-gray-600 mb-6">
        I help traders turn their ideas into working MQL5 tools — from automation to alerts.
      </p>

      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        <ServiceCard
          v-for="(service, index) in services"
          :key="index"
          :title="service.title"
          :description="service.description"
          :icon="service.icon"
          class="opacity-0 animate-fadeInUp"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ServiceCard from "@/components/ServiceCard.vue";

export default {
  name: "ServicesPage",
  components: {
    ServiceCard,
  },
  data() {
    return {
      services: [
        {
          title: "Custom Strategy Automation",
          description: "Automate your manual or rule-based trading strategy into a fully coded MT5 Expert Advisor (EA).",
          icon: ["fas", "cogs"],
        },
        {
          title: "Indicator ↔ EA Conversion",
          description: "Turn indicators into EAs or EAs into visual indicators, while keeping all alerts and logic intact.",
          icon: ["fas", "exchange-alt"],
        },
        {
          title: "EA Debugging & Optimization",
          description: "Fix bugs, improve performance, or refactor your existing EA for better speed and logic flow.",
          icon: ["fas", "tools"],
        },
        {
          title: "Telegram/Email Alert Systems",
          description: "Get custom alerts sent directly to Telegram or email based on your chosen trading conditions.",
          icon: ["fas", "bell"],
        },
        {
          title: "Pine Script ↔ MQL5 Conversion",
          description: "Convert TradingView Pine Script strategies or indicators into working MQL5 code and vice versa.",
          icon: ["fas", "code-branch"],
        },
        {
          title: "Dashboards & Visual Tools",
          description: "Build tools like trade panels, strategy testers, or market dashboards for MT5 with full control.",
          icon: ["fas", "chart-bar"],
        },
        {
          title: "1-on-1 Consultation",
          description: "Need help shaping your strategy idea? Book a consultation and we’ll figure out the best way forward.",
          icon: ["fas", "user"],
        },
      ],
    };
  },
};
</script>